module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-16.9dd10867.png";